import axios from 'axios';
import { useCallback, useState } from 'react';
import { store } from '../factory';

interface UsePresignedUrlReturn {
  getPresignedUrl: (
    fileType: string,
    eventID: string
  ) => Promise<{ presignedUrl: string; fileKey: string } | undefined>;
  loading: boolean;
  error: string | undefined;
}

export const useGetGuestBookPresignedUrl = (): UsePresignedUrlReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const { environment } = store.getState();

  const getPresignedUrl = useCallback(
    async (fileType: string, eventID: string) => {
      setLoading(true);
      setError(undefined);

      try {
        const response = await axios.request({
          method: 'get',
          baseURL: environment.REST_URI,
          url: '/api/v1/guest-book/upload-url',
          params: { fileType, eventID },
          headers: { 'Content-Type': 'application/json' }
        });

        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response.data;
      } catch (error_: unknown) {
        console.error('Error fetching presigned URL:', error_);
        setError('Failed to fetch presigned URL');

        return undefined;
      } finally {
        setLoading(false);
      }
    },
    [environment.REST_URI]
  );

  return {
    getPresignedUrl,
    loading,
    error
  };
};
